module.exports = __webpack_public_path__ + "static/media/hero-img-2.32b036a5.png";